export default "__VITE_ASSET__1c8de742__"